/*eslint-disable sort-keys */

const searchDisplayTypes = {
    DISPLAY_AUCTION: 'DISPLAY_AUCTION',
    DISPLAY_PRICE_RESULTS: 'DISPLAY_PRICE_RESULTS',
} as const;

export default searchDisplayTypes;
